import { helper } from '@ember/component/helper';

export function noopExtra() {
  return (maybeEvent: unknown) => {
    if (maybeEvent != null && typeof maybeEvent === 'object' && 'preventDefault' in maybeEvent) {
      (maybeEvent as Event).preventDefault();
    }

    return;
  };
}

export default helper(noopExtra);
